module.exports = __webpack_public_path__ + "img/eggbreak.b40b13f2.gif";